const state = {
  filterType: "day",
  filterTeacher: null,
  filterEvent: null,
};

const mutations = {
  Set_Type(state, type) {
    state.filterType = type;
  },
  Set_Teacher(state, teacher) {
    state.filterTeacher = teacher;
  },
  Set_Event(state, event) {
    state.filterEvent = event;
  },
};

const actions = {
  setFilterType({ commit }, type) {
    commit("Set_Type", type);
  },
  setFilterTeacher({ commit }, teacher) {
    commit("Set_Teacher", teacher);
  },
  setFilterEvent({ commit }, event) {
    commit("Set_Event", event);
  },
};

const getters = {
  filterType: (state) => {
    return state.filterType;
  },
  filterTeacher: (state) => {
    return state.filterTeacher;
  },
  filterEvent: (state) => {
    return state.filterEvent;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
